import {
  AutoAssignCardSeriesDto,
  CardSeriesApiFp,
  CardSeriesControllerGet200Response,
  DeleteCardSeriesDto,
  GenerateCardSeriesDto,
  GetCardSeriesDto,
  MessageResponseDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseCardSeriesModel = CardSeriesControllerGet200Response;
export type GetCardSeriesModel = GetCardSeriesExtendDto;
export type MutateResponseCardSeriesModel = MessageResponseDto;
export type CreateCardSeriesModel = GenerateCardSeriesDto;
export type DeleteCardSeriesModel = DeleteCardSeriesDto;
export type AutoAssignCardSeriesModel = AutoAssignCardSeriesDto;

export interface GetCardSeriesExtendDto extends Partial<GetCardSeriesDto> {
  user_code: string;
}
export interface ActivateCardSeriesModel {
  code: string;
  user_code: string;
  pin?: number;
}

export const apiCardSeriesFp = CardSeriesApiFp(apiConfig);
export const getCardSeriesController = apiCardSeriesFp.cardSeriesControllerGet;
export const generateCardSeriesController =
  apiCardSeriesFp.cardSeriesControllerGenerate;
export const activateCardSeriesController =
  apiCardSeriesFp.cardSeriesControllerActivate;
export const deleteCardSeriesController =
  apiCardSeriesFp.cardSeriesControllerDelete;
export const autoAssignCardSeriesController =
  apiCardSeriesFp.cardSeriesControllerAutoAssign;

export const QueryKeyCardSeries = QueryKey.CardSeries;
